import React from 'react'
import OrangeFTEAnalysis from '../components/dashboard/OrangeFTEAnalysis'

// OrangeFTEAnalysis renders its own <ReportShell> internally.
const OrangeFTEAnalysisPage = () => <OrangeFTEAnalysis />

export default OrangeFTEAnalysisPage
